import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { MyTimeOffRequestsQueryParams } from '../types';

/** The only paginated list in this module — the rest return plain arrays. */
export function useMyTimeOffRequests(params?: MyTimeOffRequestsQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.myRequests(orgId, params),
    queryFn: ({ signal }) => timeOffService.getMyRequests(params, signal),
    staleTime: 60_000,
    enabled: !!orgId,
  });
}
